import {Box} from "@chakra-ui/react";
import RentalTable from "../../../components/tables/RentalTable";
import React, {useEffect, useState} from "react";
import {getData} from "../../../services/api";

export default function Rentals() {

    const [tableData, setTableData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const columnsData = [
        {
            Header: "ID",
            accessor: "uuid",
        },
        {
            Header: "QUELLE",
            accessor: "source",
        },
        {
            Header: "KUNDE",
            accessor: (row) => `${row.user} ${row.email}`,
        },
        {
            Header: "TITEL",
            accessor: "title",
        },
        {
            Header: "ANGELEGT AM",
            accessor: "created_at",
        },
        {
            Header: "STATUS",
            accessor: "status",
        },
    ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await getData('/api/rentals');
                setTableData(result.data);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleDelete = (id) => {
        setTableData(prevData => prevData.filter(item => item.id !== id));
    };

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
        {loading ? (
            <div>Loading...</div>
        ) : error ? (
            <div>Error: {error}</div>
        ) : tableData ? (
            <RentalTable columnsData={columnsData} tableData={tableData} onDelete={handleDelete}/>
        ) : (
            <div>Keine Daten gefunden</div>
        )}
    </Box>
  );
}
